<SimpleField {label} {required} {hints} {stacked}>
  <Select 
    bind:value={value}
    options={options}
    {size} w={width}
    {disabled} 
    bg="white" 
    />
</SimpleField>

<script>
  import { Select } from 'svelte-stylo'
  import SimpleField from './SimpleField.svelte'

  export let 
    label = '',
    required = null,
    options = [],
    size = "100%",
    disabled = null,
    hints = null,
    stacked = false,
    value;

  let
    width = (size === '100%') ? size : null;

</script>
